
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class TipologieEsperienzeDialog extends Serenity.EntityDialog<TipologieEsperienzeRow, any> {
        protected getFormKey() { return TipologieEsperienzeForm.formKey; }
        protected getIdProperty() { return TipologieEsperienzeRow.idProperty; }
        protected getLocalTextPrefix() { return TipologieEsperienzeRow.localTextPrefix; }
        protected getNameProperty() { return TipologieEsperienzeRow.nameProperty; }
        protected getService() { return TipologieEsperienzeService.baseUrl; }
        protected getDeletePermission() { return TipologieEsperienzeRow.deletePermission; }
        protected getInsertPermission() { return TipologieEsperienzeRow.insertPermission; }
        protected getUpdatePermission() { return TipologieEsperienzeRow.updatePermission; }

        protected form = new TipologieEsperienzeForm(this.idPrefix);

    }
}